import { render, staticRenderFns } from "./inspectionDanger.vue?vue&type=template&id=296c2f34&scoped=true&"
import script from "./inspectionDanger.vue?vue&type=script&lang=js&"
export * from "./inspectionDanger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296c2f34",
  null
  
)

export default component.exports